export const PER_PAGE = [25, 50, 75, 100];
export const DEFAULT_PER_PAGE = PER_PAGE[0];
export const DEFAULT_OFFSET = 0;
export const MAX_SIDE_PAGINATION_PAGES = 6;
export const SORT_DIRECTION = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
};
